export default "__VITE_ASSET__QlJxigVY__"